/**
 * @generated SignedSource<<81929a9bfaa8da6b3bf89218833499f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FormResponseState = "DRAFT" | "SUBMITTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RespondForm_Response$data = {
  readonly answers: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly value: {
      readonly __typename: "CustomValue__Checkboxes";
      readonly checkboxes: ReadonlyArray<string> | null;
    } | {
      readonly __typename: "CustomValue__Date";
      readonly date: DateString  | null;
    } | {
      readonly __typename: "CustomValue__DateTime";
      readonly dateTime: ISO8601DateTimeString | null;
    } | {
      readonly __typename: "CustomValue__Email";
      readonly email: string | null;
    } | {
      readonly __typename: "CustomValue__Link";
      readonly link: string | null;
    } | {
      readonly __typename: "CustomValue__MultipleChoice";
      readonly multipleChoice: string | null;
    } | {
      readonly __typename: "CustomValue__Numeric";
      readonly number: number | null;
    } | {
      readonly __typename: "CustomValue__PhoneNumber";
      readonly phoneNumber: string | null;
    } | {
      readonly __typename: "CustomValue__String";
      readonly text: string | null;
    } | {
      readonly __typename: "CustomValue__Time";
      readonly time: TimeOfDayString | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  }>;
  readonly id: string;
  readonly respondedAt: ISO8601DateTimeString | null;
  readonly responder: {
    readonly name: string;
  };
  readonly state: FormResponseState;
  readonly " $fragmentType": "RespondForm_Response";
};
export type RespondForm_Response$key = {
  readonly " $data"?: RespondForm_Response$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondForm_Response">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondForm_Response",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "respondedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "responder",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormResponseAnswer",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "questionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "text",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__String",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "number",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__Numeric",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "checkboxes",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__Checkboxes",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "multipleChoice",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__MultipleChoice",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "date",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__Date",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "time",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__Time",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "dateTime",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__DateTime",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "phoneNumber",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__PhoneNumber",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "link",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__Link",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "email",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "CustomValue__Email",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FormResponse",
  "abstractKey": null
};
})();

(node as any).hash = "2f8a472c8e8e9bafab6ccc3feff7d37e";

export default node;
